<template>
  <div class="reenviar">
    <p v-if="feedback" class="reenviar-feedback" :class="{ erro: !sucesso }">{{ feedback }}</p>
    <button
      class="reenviar-btn"
      :disabled="enviando || espera > 0"
      @click="reenviar"
    >
      <template v-if="enviando">Enviando…</template>
      <template v-else-if="espera > 0">Aguarde {{ espera }}s para reenviar</template>
      <template v-else>Não recebeu o e-mail? Reenviar</template>
    </button>
  </div>
</template>

<script>
import { reenviarConfirmacaoPublica } from '../../lib/inscricao'

/**
 * Cada acerto vira um e-mail de verdade saindo pelo Resend. A janela local
 * evita o clique repetido de quem nao viu o e-mail chegar ainda — o limite do
 * servidor continua sendo a defesa real, essa e so a que poupa a caixa do
 * inscrito de tres copias iguais.
 */
const ESPERA_SEGUNDOS = 60

export default {
  name: 'ReenviarEmailLink',
  props: {
    inscricaoId: { type: String, required: true }
  },
  data() {
    return { enviando: false, espera: 0, feedback: '', sucesso: false, timer: null }
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    async reenviar() {
      this.enviando = true
      this.feedback = ''
      try {
        const res = await reenviarConfirmacaoPublica(this.inscricaoId)
        this.sucesso = true
        this.feedback = res?.message || 'E-mail reenviado.'
        this.iniciarEspera()
      } catch (err) {
        this.sucesso = false
        this.feedback = err.response?.data?.message || 'Não conseguimos reenviar agora. Tente de novo em alguns minutos.'
        // Erro tambem trava o botao: se o servidor recusou por limite, insistir
        // na hora so devolve o mesmo erro.
        this.iniciarEspera()
      } finally {
        this.enviando = false
      }
    },
    iniciarEspera() {
      this.espera = ESPERA_SEGUNDOS
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.espera -= 1
        if (this.espera <= 0) clearInterval(this.timer)
      }, 1000)
    }
  }
}
</script>

<style scoped>
.reenviar { margin-top: var(--spacing-md); text-align: center; }
.reenviar-btn {
  background: none; border: none; padding: 4px 8px;
  font-size: var(--text-sm); color: var(--color-text-muted);
  text-decoration: underline; cursor: pointer;
}
.reenviar-btn:disabled { cursor: default; text-decoration: none; opacity: 0.7; }
.reenviar-feedback {
  font-size: var(--text-sm); color: var(--color-text-primary);
  margin-bottom: var(--spacing-xs);
}
.reenviar-feedback.erro { color: var(--color-danger); }
</style>
